module.exports = __webpack_public_path__ + "static/about-content-image-8-8ce1d693dc212e285392ee0255f03381.jpg";